// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__6C0AU","active":"Message_active__VNMPm","message__icon":"Message_message__icon__EuiYG","spin":"Message_spin__w29on","loader":"Message_loader__5b2Vd"};